import { redirect } from 'react-router-dom';
import type { IUser } from '@/models/auth';

function getStoredUser(): IUser | null {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) return null;

  try {
    return JSON.parse(storedUser) as IUser;
  } catch {
    localStorage.removeItem('user');
    return null;
  }
}

/**
 * Root loader - checks authentication and MFA status
 * Redirects to /login if unauthenticated, /mfa-setup if MFA not enabled
 */
export async function rootLoader() {
  const user = getStoredUser();

  if (!user) return redirect('/login');
  if (!user.mfaEnabled) return redirect('/mfa-setup');

  return user;
}

/**
 * MFA setup loader - requires auth but NOT MFA
 * Redirects to / if MFA already enabled
 */
export async function mfaSetupLoader() {
  const user = getStoredUser();

  if (!user) return redirect('/login');
  if (user.mfaEnabled) return redirect('/');

  return user;
}

/**
 * Admin loader - loads dashboard statistics
 */
export async function dashboardLoader() {
  // Simulate API call
  await new Promise<void>((resolve) => {
    setTimeout(() => resolve(), 500);
  });

  return {
    stats: {
      users: 1234,
      revenue: '$45,678',
      orders: 567,
      growth: '+12.5%',
    },
  };
}

/**
 * Login loader - redirects if already authenticated
 */
export async function loginLoader() {
  const storedUser = localStorage.getItem('user');

  if (storedUser) {
    return redirect('/');
  }

  return null;
}
